// An encode's SCTE-35 ad break as the detail panel says it (node cues.go).
import type { BreakStatus } from './api'
import { when, type Window } from './schedule'
import { dur } from './util'

// breakText: "ad break in 3s, 1m 00s long", "in an ad break, 37s left",
// "ad break ends in 2s", "in an ad break for 1m 05s, until ended"
export function breakText(b: BreakStatus, now: number): string {
    const starts = Date.parse(b.starts)
    const ends = b.ends ? Date.parse(b.ends) : 0
    const secs = (ms: number) => dur(Math.max(0, Math.ceil(ms / 1000)))
    if (b.ending) return `ad break ends in ${secs(ends - now)}`
    if (now < starts)
        return `ad break in ${secs(starts - now)}, ${ends ? `${secs(ends - starts)} long` : 'until ended'}`
    if (ends) return `in an ad break, ${secs(ends - now)} left`
    return `in an ad break for ${dur(Math.floor((now - starts) / 1000))}, until ended`
}

// newBreak is the break "+ window" adds: 2 minutes from the next quarter
// hour at least 10 minutes away; after the last one, the same length half
// an hour after it ends.
export function newBreak(ws: Window[], now: Date): Window {
    const last = [...ws].sort((a, b) => a.start.localeCompare(b.start)).at(-1)
    if (last) {
        const len = Date.parse(last.stop) - Date.parse(last.start)
        const start = Date.parse(last.stop) + 30 * 60_000
        return { start: new Date(start).toISOString(), stop: new Date(start + len).toISOString() }
    }
    const q = 15 * 60_000
    const start = Math.ceil((now.getTime() + 10 * 60_000) / q) * q
    return { start: new Date(start).toISOString(), stop: new Date(start + 2 * 60_000).toISOString() }
}

// nextBreakText: the next scheduled break not cued yet, "next ad break
// 14:15, 2m 00s long" ("" when none)
export function nextBreakText(ws: Window[] | undefined, now: Date): string {
    const next = (ws ?? [])
        .filter((w) => !w.started && Date.parse(w.start) > now.getTime())
        .sort((a, b) => a.start.localeCompare(b.start))[0]
    if (!next) return ''
    return `next ad break ${when(next.start, now)}, ${dur((Date.parse(next.stop) - Date.parse(next.start)) / 1000)} long`
}
